import {
  checkProductAvailability,
  retrieveProductFromShop,
  calculateTotalItemPrice,
} from "./productUtils";

export const changeItemQuantity = (
  operation,
  products,
  index,
  retrieveUpdatedCartItems,
  enqueueSnackbar,
) => {
  let cartItems = JSON.parse(localStorage.getItem("cart_items"));
  const productFromShop = retrieveProductFromShop(products, cartItems[index]);

  if (operation === "minus") {
    if (cartItems[index].quantity > 1) {
      cartItems[index].quantity = cartItems[index].quantity - 1;
    }
  } else if (operation === "add") {
    cartItems[index].quantity = cartItems[index].quantity + 1;
    if (
      productFromShop.inventory !== null &&
      cartItems[index].quantity > productFromShop.inventory
    ) {
      enqueueSnackbar("Sorry, there is not enough left in stock for this product!", {
        variant: "error",
      });
      return;
    }
  }

  localStorage.setItem("cart_items", JSON.stringify(cartItems));
  retrieveUpdatedCartItems();
};

export const removeItemFromCart = (index, retrieveUpdatedCartItems) => {
  let cartItems = JSON.parse(localStorage.getItem("cart_items"));
  cartItems.splice(index, 1);
  if (cartItems.length > 0) {
    localStorage.setItem("cart_items", JSON.stringify(cartItems));
  } else {
    localStorage.removeItem("cart_items");
  }
  retrieveUpdatedCartItems();
};

export const checkCartItems = (products, cartItems) => {
  if (cartItems.length > 0) {
    for (const item of cartItems) {
      const productFromShop = retrieveProductFromShop(products, item);
      if (!checkProductAvailability(productFromShop)) {
        return false;
      }

      if (
        productFromShop.inventory !== null &&
        (productFromShop.inventory === 0 || item.quantity > productFromShop.inventory)
      ) {
        return false;
      }
    }
  }
  return true;
};

export const calculateTotalCartPrice = (items) => {
  let totalPrice = 0;
  items.forEach((item) => {
    const price = calculateTotalItemPrice(item) * item.quantity;
    totalPrice += price;
  });

  return totalPrice;
};

export const checkIfItemExistInCart = (newItem) => {
  let check = false;
  let index = null;
  if (localStorage.getItem("cart_items")) {
    const cart = JSON.parse(localStorage.getItem("cart_items"));

    const arraysEqual = (a1, a2) =>
      a1.length === a2.length && a1.every((o, idx) => objectsEqual(o, a2[idx]));
    const objectsEqual = (o1, o2) => {
      return o1 !== null && typeof o1 === "object" && Object.keys(o1).length > 0
        ? Object.keys(o1).length === Object.keys(o2).length &&
            Object.keys(o1).every((p) => objectsEqual(o1[p], o2[p]))
        : o1 === o2;
    };

    // first check if any cart items have the same product_id
    if (cart.filter((item) => item.product_id === newItem.product_id).length > 0) {
      // next check if responses are the same
      for (let i = 0; i < cart.length; i++) {
        if (cart[i].product_id === newItem.product_id) {
          if (newItem.responses.length === cart[i].responses.length) {
            if (newItem.responses.length === 0) {
              // for product that do not have responses
              check = true;
              index = i;
              return { check, index };
            }
            for (let j = 0; j < newItem.responses.length; j++) {
              if (
                cart[i].responses.filter(
                  (item) => item.question_id === newItem.responses[j].question_id,
                ).length > 0
              ) {
                const response = cart[i].responses.filter(
                  (item) => item.question_id === newItem.responses[j].question_id,
                )[0];

                // compare selected options in the response
                if (response.selected_options && newItem.responses[j].selected_options) {
                  if (
                    Array.isArray(response.selected_options) &&
                    response.selected_options.length > 0 &&
                    newItem.responses[j].selected_options &&
                    Array.isArray(newItem.responses[j].selected_options) &&
                    newItem.responses[j].selected_options.length > 0
                  ) {
                    // console.log("MRQ");
                    if (
                      arraysEqual(newItem.responses[j].selected_options, response.selected_options)
                    ) {
                      // console.log("MRQ same");
                      check = true;
                      index = i;
                    } else {
                      // console.log("MRQ diff");
                      check = false;
                      break;
                    }
                  } else if (
                    typeof response.selected_options === "object" &&
                    response.hasOwnProperty("selected_options")
                  ) {
                    // console.log("SELECT");
                    if (
                      newItem.responses[j].hasOwnProperty("selected_options") &&
                      newItem.responses[j].selected_options.option_id ===
                        response.selected_options.option_id
                    ) {
                      // console.log("SELECT same");
                      check = true;
                      index = i;
                    } else {
                      // console.log("SELECT diff");
                      check = false;
                      break;
                    }
                  } else {
                    // console.log("SA");
                    if (newItem.responses[j].selected_options === response.selected_options) {
                      // console.log("SA same");
                      check = true;
                      index = i;
                    } else {
                      // console.log("SA diff");
                      check = false;
                      break;
                    }
                  }
                } else {
                  // console.log("NO RESPONSE");
                  if (!response.selected_options && !newItem.responses[j].selected_options) {
                    check = true;
                    index = i;
                  } else {
                    check = false;
                    break;
                  }
                }
              }
            }
            if (check) {
              return { check, index };
            }
          }
        }
      }
      return { check, index };
    }
  }
  return { check, index };
};

export const getExistingQuantity = (cart, newItem) => {
  const qtyObj = cart
    .filter((item) => item.product_id === newItem.product_id)
    .reduce(
      (a, b) => {
        return { quantity: a.quantity + b.quantity };
      },
      { quantity: 0 },
    );
  return qtyObj.quantity;
};

export const addItemToCart = (
  products,
  product,
  responses,
  quantity,
  retrieveUpdatedCartItems,
  enqueueSnackbar,
) => {
  const newItem = {
    ...product,
    responses: responses,
    quantity: quantity,
  };
  const productFromShop = retrieveProductFromShop(products, newItem);
  const { check, index } = checkIfItemExistInCart(newItem);
  let cart;
  if (check) {
    cart = JSON.parse(localStorage.getItem("cart_items"));
    if (newItem.inventory !== null) {
      const existingQty = getExistingQuantity(cart, newItem);
      if (existingQty + newItem.quantity > productFromShop.inventory) {
        enqueueSnackbar("Sorry, there is not enough left in stock for this product!", {
          variant: "error",
        });
        return false;
      }
    }
    cart[index].quantity += newItem.quantity;
    localStorage.setItem("cart_items", JSON.stringify(cart));
  } else {
    // add item to cart (store in local storage)
    if (localStorage.getItem("cart_items")) {
      cart = JSON.parse(localStorage.getItem("cart_items"));
      if (newItem.inventory !== null) {
        const existingQty = getExistingQuantity(cart, newItem);
        if (existingQty + newItem.quantity > productFromShop.inventory) {
          enqueueSnackbar("Sorry, there is not enough left in stock for this product!", {
            variant: "error",
          });
          return false;
        }
      }
      cart.push(newItem);
      localStorage.setItem("cart_items", JSON.stringify(cart));
    } else {
      if (newItem.inventory !== null && newItem.quantity > productFromShop.inventory) {
        enqueueSnackbar("Sorry, there is not enough left in stock for this product!", {
          variant: "error",
        });
        return false;
      }
      cart = [newItem];
      localStorage.setItem("cart_items", JSON.stringify(cart));
    }
  }
  retrieveUpdatedCartItems();
  return true;
};
